/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/transaccion';


// ---------------- Saga's response ----------------
function fetchTransaccionSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchTransaccionError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchTransaccion = createAction('fetchTransaccion');

// ------------- connection ------------- //

const transaccionReducer = createSlice({
  name: 'Transaccion',
  initialState,
  reducers: {
    fetchTransaccionSuccess,
    fetchTransaccionError,
  },
});

export const transaccionAction = {
  ...transaccionReducer.actions,
  fetchTransaccion,
};

export default transaccionReducer.reducer;